<template>
  <el-drawer
    class="edit-drawer"
    size="85%"
    :wrapperClosable="false"
    :visible.sync="visible"
    @close="handleClose"
    :show-close="false"
  >
    <template slot="title">
      <span class="el-drawer__title">AI改图</span>
      <el-tooltip content="AI 图片生成过程中，请谨慎点击关闭按钮" placement="bottom">
        <button
          @click="handleCloseClick"
          type="button"
          class="el-drawer__close-btn"
          style="position: static;"
        >
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
      </el-tooltip>
    </template>
    <div style="width:100%;height:100%;position:relative;">
      <div v-if="loading" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#909399;background-color:rgba(255,255,255,0.7);z-index:1;">
        <i class="el-icon-loading" style="margin-right:8px;"></i>
        <span>正在加载编辑器...</span>
      </div>
      <div v-if="error" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#f56c6c;">
        <i class="el-icon-warning" style="margin-right:8px;"></i>
        <span>编辑器加载失败，请稍后重试</span>
      </div>
      <iframe
        v-if="visible"
        ref="aiIframe"
        id="aiEditor"
        :src="iframeSrc"
        frameborder="0"
        width="100%"
        height="100%"
        @load="handleIframeLoad"
        @error="handleIframeError"
      />
    </div>
  </el-drawer>
</template>

<script>
import { getLingganVerify } from '@/api/linggan/index.js';

export default {
  name: 'AiEditor',
  data() {
    return {
      visible: false,
      iframeSrc: '',
      loading: false,
      error: false,
      // 通过 method_open 传入的配置，如图片地址、文件名、回调等
      opts: {},
    };
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    /**
     * 打开 AI 改图编辑器
     * opts: { imgUrl: string, imgName?: string, okFn?: Function }
     */
    async method_open(opts = {}) {
      this.opts = opts;
      this.visible = true;
      this.loading = true;
      this.error = false;

      try {
        // 调用接口获取重定向地址
        const res = await getLingganVerify( {}, { isNeedLoading: false });
        if (res && res.result === 1 && res.data) {
          const { data: { redirectUrl } } = res.data
          this.iframeSrc = redirectUrl;
        } else {
          this.error = true;
          this.$message.error('获取编辑器地址失败');
        }
      } catch (e) {
        this.error = true;
        this.$message.error('获取编辑器地址异常');
      }
    },
    /** 关闭抽屉并清理状态 */
    handleClose() {
      this.visible = false;
      this.iframeSrc = '';
      this.loading = false;
      this.error = false;
      window.removeEventListener('message', this.handleMessage);
      this.opts = {};
    },
    handleCloseClick() {
      this.handleClose();
    },
    /** iframe 加载完成，绑定通信并发送初始化配置 */
    handleIframeLoad() {
      this.loading = false;
      this.error = false;
      window.addEventListener('message', this.handleMessage);
      this.sendInitConfig();
    },
    /** iframe 加载失败 */
    handleIframeError() {
      this.loading = false;
      this.error = true;
    },
    /**
     * 发送 INIT_CONFIG 初始化消息到 iframe
     * 遵循 AI 改图 iframe 对接文档规范
     */
    sendInitConfig() {
      try {
        const iframeElement = this.$refs.aiIframe;
        if (!iframeElement || !iframeElement.contentWindow) return;
        const message = {
          type: 'INIT_CONFIG',
          data: {
            route: 'CLOTH_MODEL',
            images: [
              {
                url: this.opts.imgUrl,
                originFileName: this.opts.imgName || 'image.jpg',
                productCode: this.opts.productCode || '',
                label: this.opts.label || '',
              },
            ],
            buttons: [
              { id: 'save', label: '保存', type: 'primary', callbackType: 'SAVE_IMAGE' },
            ],
          },
        };
        // 使用项目现有的 postMessage 实现方式
        iframeElement.contentWindow.postMessage(message, '*');
      } catch (e) {
        // 发送失败不阻断流程，仅输出日志
        console.error('发送初始化配置失败', e);
      }
    },
    /**
     * 监听 iframe 消息，支持默认与自定义回调类型
     */
    handleMessage(event) {
      const { type, data } = event.data || {};
      if (!type) return;
      if (type === 'BUTTON_CLICK_CALLBACK') {
        this.handleButtonCallback(data);
        return;
      }
      switch (type) {
        case 'SAVE_IMAGE':
          this.handleButtonCallback({ ...data, callbackType: 'SAVE_IMAGE' });
          break;
        default:
          break;
      }
    },
    /**
     * 统一处理按钮点击的回调逻辑
     */
    handleButtonCallback(data = {}) {
      const { callbackType, imageUrl } = data;
      switch (callbackType) {
        case 'SAVE_IMAGE':
          if (imageUrl) {
            // 回传给父组件的回调
            this.opts.okFn && this.opts.okFn(imageUrl);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: 700;
    color: #3e4144;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
  }
  ::v-deep .el-drawer__body {
    padding: 10px 20px;
  }
}
</style>